// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-container {
  width: 250px;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  overflow-x: visible;
  z-index: 1000;
  transition: width 0.3s ease;
}

.sidebar-container.collapsed {
  width: 70px;
}

.sidebar {
  background: #028661;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 80px !important;
}

.sidebar h4 {
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 8px;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  margin-left: 8px;
  font-size: 1.4rem;
  font-weight: bold;
}

.sidebar h4 i {
  min-width: 20px;
  text-align: center;
}

.toggle-sidebar-btn {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
  position: fixed;
  bottom: 20px;
  left: 190px;
  z-index: 1001;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.toggle-sidebar-btn:hover {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.15));
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transform: scale(1.05);
}

.toggle-sidebar-btn:active {
  transform: scale(0.95);
}

.toggle-sidebar-btn i {
  font-size: 14px;
  transition: transform 0.3s ease;
}

.sidebar .nav-link {
  color: #ecf0f1;
  padding: 8px 10px;
  border-radius: 5px;
  margin-bottom: 4px;
  transition: all 0.3s ease;
  text-decoration: none;
  font-size: 15px;
}

.sidebar .nav-link:hover {
  background: #03a075;
  color: #fff;
}

.sidebar .nav-link.active {
  background: #03a075;
  color: #fff;
}

.dashboard-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 10px;
  border-radius: 5px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
  color: #ecf0f1;
  cursor: pointer;
  text-decoration: none;
  font-size: 15px;
}

.dashboard-title:hover {
  background: #03a075;
  color: #fff;
}

.dashboard-title i {
  margin-right: 10px;
  width: 18px;
  text-align: center;
}

.sidebar-container.collapsed .dashboard-title i {
  margin-right: 0;
  width: auto;
}

/* Module specific colors for nav links */
.module-1-link:hover {
  background: #028661 !important;
}

.module-2-link:hover {
  background: #9b59b6 !important;
}

.module-3-link:hover {
  background: #e67e22 !important;
}

.module-4-link:hover {
  background: #1abc9c !important;
}

.module-5-link:hover {
  background: #27ae60 !important;
}

.module-6-link:hover {
  background: #8e44ad !important;
}

.module-7-link:hover {
  background: #d35400 !important;
}

.module-8-link:hover {
  background: #2980b9 !important;
}

/* Collapsible menu styles */
.module-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 5px;
  margin-bottom: 4px;
  transition: all 0.3s ease;
  color: #ecf0f1;
  font-size: 15px;
}

.module-header:hover {
  background: #03a075;
  text-decoration: none;
  color: #fff;
}

.module-header.active {
  background: #028661;
  color: white;
}

.module-title {
  display: flex;
  align-items: center;
}

.module-title i {
  margin-right: 10px;
  width: 18px;
  text-align: center;
}

.sidebar-container.collapsed .module-title i {
  margin-right: 0;
  width: auto;
}

.toggle-icon {
  transition: transform 0.3s ease;
  font-size: 0.8rem;
}

.toggle-icon.expanded {
  transform: rotate(90deg);
}

.submenu-container {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  margin-left: 0;
  margin-bottom: 4px;
  padding-left: 10px;
  text-align: left;
}

.submenu-container.expanded {
  max-height: 500px;
}

.submenu-container .nav-link {
  padding: 8px 10px;
  color: #ecf0f1;
  border-radius: 5px;
  margin-bottom: 4px;
  transition: all 0.3s ease;
  text-decoration: none;
  display: block;
  font-size: 14px;
}

/* Scrollbar styling */
.sidebar-container::-webkit-scrollbar {
  width: 8px;
}

.sidebar-container::-webkit-scrollbar-track {
  background: #027a59;
}

.sidebar-container::-webkit-scrollbar-thumb {
  background: #03a075;
  border-radius: 4px;
}

.sidebar-container::-webkit-scrollbar-thumb:hover {
  background: #028661;
}

/* Main content adjustment when sidebar is present */
.main-content-with-sidebar {
  margin-left: 250px;
  background: #f5f6f7;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: margin-left 0.3s ease;
}

/* Collapsed sidebar styles */
.sidebar-container.collapsed+.main-content-with-sidebar {
  margin-left: 70px;
}

.sidebar-container.collapsed .dashboard-title span,
.sidebar-container.collapsed .module-title span {
  display: none;
}

.sidebar-container.collapsed .module-header {
  justify-content: center;
  padding: 10px 0;
}

.sidebar-container.collapsed .module-title {
  justify-content: center;
}

.sidebar-container.collapsed .dashboard-title {
  justify-content: center;
  padding: 10px 0;
}

.sidebar-container.collapsed h4 {
  justify-content: center;
  padding: 0;
}

.sidebar-container.collapsed h4 i {
  margin-right: 0;
  width: auto;
}

.sidebar-container.collapsed .toggle-sidebar-btn {
  left: 15px;
}

/* Tutorial link button */
.tutorial-link-btn {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1001;
  color: #ecf0f1;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: flex;
  align-items: center;
  height: 40px;
}

.tutorial-link-btn:hover {
  color: #fff;
  text-decoration: underline;
}

.sidebar-container.collapsed .tutorial-link-btn {
  display: none;
}

/* Popup submenu for collapsed sidebar */
.submenu-popup {
  position: fixed;
  left: 70px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  max-width: 280px;
  z-index: 9999;
  overflow: visible;
  animation: slideIn 0.2s ease;
  pointer-events: auto;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.submenu-popup-header {
  background: #028661;
  color: #fff;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.submenu-popup-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  color: #2c3e50;
  text-decoration: none;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}

.submenu-popup-link:last-child {
  border-bottom: none;
}

.submenu-popup-link:hover {
  background: #f8f9fa;
  color: #028661;
  padding-left: 20px;
}

.submenu-popup-link i {
  width: 20px;
  text-align: center;
  color: #028661;
}

.submenu-popup-link span {
  font-size: 14px;
}

.submenu-popup-link.active {
  background: #f8f9fa;
  color: #028661;
  padding-left: 20px;
}

/* Position popup menu relative to module item */
.module-item {
  position: relative;
  z-index: 1;
}

.module-item:hover {
  z-index: 9998;
}

.page-content {
  padding: 0;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yFAAyF;EACzF,0CAA0C;EAC1C,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,yFAAyF;EACzF,sCAAsC;EACtC,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".sidebar-container {\n  width: 250px;\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  overflow-y: auto;\n  overflow-x: visible;\n  z-index: 1000;\n  transition: width 0.3s ease;\n}\n\n.sidebar-container.collapsed {\n  width: 70px;\n}\n\n.sidebar {\n  background: #028661;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding-bottom: 80px !important;\n}\n\n.sidebar h4 {\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  gap: 8px;\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n  margin-left: 8px;\n  font-size: 1.4rem;\n  font-weight: bold;\n}\n\n.sidebar h4 i {\n  min-width: 20px;\n  text-align: center;\n}\n\n.toggle-sidebar-btn {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n  position: fixed;\n  bottom: 20px;\n  left: 190px;\n  z-index: 1001;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.toggle-sidebar-btn:hover {\n  background: linear-gradient(135deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.15));\n  border-color: rgba(255, 255, 255, 0.3);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transform: scale(1.05);\n}\n\n.toggle-sidebar-btn:active {\n  transform: scale(0.95);\n}\n\n.toggle-sidebar-btn i {\n  font-size: 14px;\n  transition: transform 0.3s ease;\n}\n\n.sidebar .nav-link {\n  color: #ecf0f1;\n  padding: 8px 10px;\n  border-radius: 5px;\n  margin-bottom: 4px;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  font-size: 15px;\n}\n\n.sidebar .nav-link:hover {\n  background: #03a075;\n  color: #fff;\n}\n\n.sidebar .nav-link.active {\n  background: #03a075;\n  color: #fff;\n}\n\n.dashboard-title {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 8px 10px;\n  border-radius: 5px;\n  margin-bottom: 8px;\n  transition: all 0.3s ease;\n  color: #ecf0f1;\n  cursor: pointer;\n  text-decoration: none;\n  font-size: 15px;\n}\n\n.dashboard-title:hover {\n  background: #03a075;\n  color: #fff;\n}\n\n.dashboard-title i {\n  margin-right: 10px;\n  width: 18px;\n  text-align: center;\n}\n\n.sidebar-container.collapsed .dashboard-title i {\n  margin-right: 0;\n  width: auto;\n}\n\n/* Module specific colors for nav links */\n.module-1-link:hover {\n  background: #028661 !important;\n}\n\n.module-2-link:hover {\n  background: #9b59b6 !important;\n}\n\n.module-3-link:hover {\n  background: #e67e22 !important;\n}\n\n.module-4-link:hover {\n  background: #1abc9c !important;\n}\n\n.module-5-link:hover {\n  background: #27ae60 !important;\n}\n\n.module-6-link:hover {\n  background: #8e44ad !important;\n}\n\n.module-7-link:hover {\n  background: #d35400 !important;\n}\n\n.module-8-link:hover {\n  background: #2980b9 !important;\n}\n\n/* Collapsible menu styles */\n.module-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 8px 10px;\n  border-radius: 5px;\n  margin-bottom: 4px;\n  transition: all 0.3s ease;\n  color: #ecf0f1;\n  font-size: 15px;\n}\n\n.module-header:hover {\n  background: #03a075;\n  text-decoration: none;\n  color: #fff;\n}\n\n.module-header.active {\n  background: #028661;\n  color: white;\n}\n\n.module-title {\n  display: flex;\n  align-items: center;\n}\n\n.module-title i {\n  margin-right: 10px;\n  width: 18px;\n  text-align: center;\n}\n\n.sidebar-container.collapsed .module-title i {\n  margin-right: 0;\n  width: auto;\n}\n\n.toggle-icon {\n  transition: transform 0.3s ease;\n  font-size: 0.8rem;\n}\n\n.toggle-icon.expanded {\n  transform: rotate(90deg);\n}\n\n.submenu-container {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n  margin-left: 0;\n  margin-bottom: 4px;\n  padding-left: 10px;\n  text-align: left;\n}\n\n.submenu-container.expanded {\n  max-height: 500px;\n}\n\n.submenu-container .nav-link {\n  padding: 8px 10px;\n  color: #ecf0f1;\n  border-radius: 5px;\n  margin-bottom: 4px;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: block;\n  font-size: 14px;\n}\n\n/* Scrollbar styling */\n.sidebar-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.sidebar-container::-webkit-scrollbar-track {\n  background: #027a59;\n}\n\n.sidebar-container::-webkit-scrollbar-thumb {\n  background: #03a075;\n  border-radius: 4px;\n}\n\n.sidebar-container::-webkit-scrollbar-thumb:hover {\n  background: #028661;\n}\n\n/* Main content adjustment when sidebar is present */\n.main-content-with-sidebar {\n  margin-left: 250px;\n  background: #f5f6f7;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: margin-left 0.3s ease;\n}\n\n/* Collapsed sidebar styles */\n.sidebar-container.collapsed+.main-content-with-sidebar {\n  margin-left: 70px;\n}\n\n.sidebar-container.collapsed .dashboard-title span,\n.sidebar-container.collapsed .module-title span {\n  display: none;\n}\n\n.sidebar-container.collapsed .module-header {\n  justify-content: center;\n  padding: 10px 0;\n}\n\n.sidebar-container.collapsed .module-title {\n  justify-content: center;\n}\n\n.sidebar-container.collapsed .dashboard-title {\n  justify-content: center;\n  padding: 10px 0;\n}\n\n.sidebar-container.collapsed h4 {\n  justify-content: center;\n  padding: 0;\n}\n\n.sidebar-container.collapsed h4 i {\n  margin-right: 0;\n  width: auto;\n}\n\n.sidebar-container.collapsed .toggle-sidebar-btn {\n  left: 15px;\n}\n\n/* Tutorial link button */\n.tutorial-link-btn {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  z-index: 1001;\n  color: #ecf0f1;\n  font-size: 14px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.tutorial-link-btn:hover {\n  color: #fff;\n  text-decoration: underline;\n}\n\n.sidebar-container.collapsed .tutorial-link-btn {\n  display: none;\n}\n\n/* Popup submenu for collapsed sidebar */\n.submenu-popup {\n  position: fixed;\n  left: 70px;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  min-width: 220px;\n  max-width: 280px;\n  z-index: 9999;\n  overflow: visible;\n  animation: slideIn 0.2s ease;\n  pointer-events: auto;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.submenu-popup-header {\n  background: #028661;\n  color: #fff;\n  padding: 12px 16px;\n  font-weight: 600;\n  font-size: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.submenu-popup-link {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  color: #2c3e50;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.submenu-popup-link:last-child {\n  border-bottom: none;\n}\n\n.submenu-popup-link:hover {\n  background: #f8f9fa;\n  color: #028661;\n  padding-left: 20px;\n}\n\n.submenu-popup-link i {\n  width: 20px;\n  text-align: center;\n  color: #028661;\n}\n\n.submenu-popup-link span {\n  font-size: 14px;\n}\n\n.submenu-popup-link.active {\n  background: #f8f9fa;\n  color: #028661;\n  padding-left: 20px;\n}\n\n/* Position popup menu relative to module item */\n.module-item {\n  position: relative;\n  z-index: 1;\n}\n\n.module-item:hover {\n  z-index: 9998;\n}\n\n.page-content {\n  padding: 0;\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
